import { ProcessTemplateFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { Item } from 'modules/processes/pages/Processes/ProcessesHomePage/Item'

interface Props {
  template: ProcessTemplateFragment
}

export const TemplateItem = ({ template }: Props) => {
  const { navigation } = useNavigation()

  const toUrl = `${navigation.processes.template.create.fullPath({
    category: template.id,
  })}?templateCategory=${template.category}`

  const toLabel = i18n.t('processes.process_from_template.submit')

  const trackCreation = () => {
    track(trackingEvents.processes.newTemplateWorkflowStarted, {
      templateId: template.id,
      category: template.category,
    })
  }

  return (
    <Item
      toUrl={toUrl}
      isNew={template.new}
      name={template.name}
      description={template.description}
      toLabel={toLabel}
      onClick={trackCreation}
    />
  )
}
